var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49986 1.27051C5.2263 1.27051 1.74951 4.7475 1.74951 9.02094C1.74951 12.2274 6.19174 18.2791 8.55668 21.2736C9.03826 21.8834 9.96147 21.8834 10.4431 21.2736C12.808 18.2791 17.2502 12.2274 17.2502 9.02094C17.2502 4.7475 13.7734 1.27051 9.49986 1.27051ZM12.9538 9.30334C12.8201 10.9816 11.4606 12.3411 9.78252 12.4748C7.64983 12.6449 5.87592 10.8708 6.04594 8.73828C6.17977 7.06006 7.5393 5.70044 9.21752 5.56702C11.3501 5.39703 13.1236 7.17084 12.9538 9.30334Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.8787807b6032320c11c37a7de33443bb.svg";
export { ForwardRef as ReactComponent };